<template>
    <div class="modal fade" id="exportRespondentsModal" ref="exportRespondentsModal" tabindex="-1" role="dialog" aria-labelledby="exportCampaignReportsModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header" style="padding-bottom: 0;">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img src="./../../assets/ics.svg" alt="ics" />
                    </button>
                </div>
                <div class="modal-body" style="padding-top: 0;">
                    <div class="row">
                        <div class="col-12 margin-top-10 margin-bottom-20">
                            <h5 class="modal-export-respondents-title">{{ $t('campaign_reports.export.export_confirmation') }}</h5>
                        </div>
                        <div class="col-12">
                            {{ $t('campaign_reports.export.export_text') }}
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="row w-100">
                        <div class="col-12 margin-bottom-5 text-align-center">
                            <span data-dismiss="modal" class="modal-footer-canvassing-orange-button cursor-pointer">{{ $t('campaign_reports.close') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: "ExportRespondentsModal",
        props: [],
        mixins: [HelperMixin],
        data() {
            return {

            }
        },
        created() {

        },
        methods: {

        },
    };
</script>